import * as React from 'react';
import { useApiRequestControllable } from '@europrocurement/l2d-modules';
import { useAchatsService } from '@europrocurement/l2d-domain';
import { reminderPublisherService } from '../services/reminderPublisherService';
import { SupplierSuggestion, SocietyEnumValue } from '../types/reminderPublisherTypes';

/**
 * Hook pour gérer les suggestions de rappels fournisseurs
 */
export function useReminderSuggestions() {
    const { request } = useApiRequestControllable();
    const [isLoading, setIsLoading] = React.useState(false);
    const [error, setError] = React.useState<Error | null>(null);
    const [suggestions, setSuggestions] = React.useState<SupplierSuggestion[]>([]);
    const { reminderPublisherApi } = useAchatsService();

    /**
     * Charge les suggestions de rappels fournisseurs
     * @param societyId ID de la société pour filtrer les résultats (optionnel)
     */
    const fetchSuggestions = React.useCallback(
        async (societyId?: SocietyEnumValue) => {
            setIsLoading(true);
            setError(null);

            try {
                const result = await reminderPublisherService.getSuggestions(
                    request,
                    reminderPublisherApi,
                    societyId,
                );
                setSuggestions(result);
                return result;
            } catch (err) {
                console.error('Erreur lors du chargement des suggestions:', err);
                setError(err instanceof Error ? err : new Error('Erreur inconnue'));
                return [];
            } finally {
                setIsLoading(false);
            }
        },
        [reminderPublisherApi, request],
    );

    return {
        suggestions,
        isLoading,
        error,
        fetchSuggestions,
    };
}
